export const RandomGreenColorHSL = () => {
  // Generate green hues (80-160 degrees) with good saturation and lightness
  const hue = Math.floor(Math.random() * 71) + 20; // 20-90 (green range)
  const saturation = Math.floor(Math.random() * 55) + 30; // 30-70% saturation
  const lightness = Math.floor(Math.random() * 31) + 25; // 35-65% lightness
  
  return `hsl(71, 55%, ${lightness}%)`;
};

export const RandomDarkGreenColorHSL = () => {
  // Generate green hues (80-160 degrees) with good saturation and lightness
  const hue = Math.floor(Math.random() * 71) + 20; // 20-90 (green range)
  const saturation = Math.floor(Math.random() * 30) + 30; // 30-70% saturation
  const lightness = Math.floor(Math.random() * 45) + 25; // 35-65% lightness
  
  return `hsl(103, 30%, ${lightness}%)`;
};

export const RandomOrangeColorHSL = () => {
  // Generate orange-yellow hues (25-55 degrees) with good saturation and lightness
  const hue = Math.floor(Math.random() * 31) + 25; // 25-55 (orange-yellow range)
  const saturation = Math.floor(Math.random() * 82) + 30; // 50-90% saturation
  const lightness = Math.floor(Math.random() * 58) + 30; // 40-70% lightness

  return `hsl(18, 82%, ${lightness}%)`;
};

export const RandomRedColorHSL = () => {
  // Generate red hues (0-15 and 345-360 degrees) with good saturation and lightness
  const isLowRed = Math.random() < 0.5;
  const hue = isLowRed 
    ? Math.floor(Math.random() * 16) // 0-15 degrees
    : Math.floor(Math.random() * 16) + 345; // 345-360 degrees
  const saturation = Math.floor(Math.random() * 84) + 30; // 50-90% saturation
  const lightness = Math.floor(Math.random() * 58) + 30; // 35-65% lightness

  return `hsl(36, 84%, ${lightness}%)`;
};

